import { MapPinIcon, SplitIcon, VectorSquareIcon } from "lucide-react"
import type { LucideIcon } from "lucide-react"
import { Badge } from "./ui/badge"
import { cn } from "~/lib/utils"

type LocationTypeId = "place" | "area" | "way" | string

const ICON_BY_TYPE: Record<string, LucideIcon> = {
  place: MapPinIcon,
  area: VectorSquareIcon,
  way: SplitIcon,
}

const LABEL_BY_TYPE: Record<string, string> = {
  place: "Place",
  area: "Area",
  way: "Way",
}

export function LocationTypeBadge({
  type,
  className,
  iconOnly = false,
}: {
  type: LocationTypeId
  className?: string
  iconOnly?: boolean
}) {
  const Icon = ICON_BY_TYPE[type]
  const label = LABEL_BY_TYPE[type] ?? type
  return (
    <Badge variant="outline" className={cn("gap-1", className)}>
      {Icon && <Icon className="w-3 h-3" />}
      {!iconOnly && <span>{label}</span>}
    </Badge>
  )
}
